export default "__VITE_ASSET__lt$P6Xw7__"